import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

// Import page components
import Homepage from '../views/Homepage';
import Exhibition from '../views/Exhibition';
import ArtistPage from '../views/ArtistPage';
import SearchResults from '../views/SearchResults';

// Import layout components
import Header from '../components/Header';
import Footer from '../components/Footer';
import ErrorDisplay from '../components/ErrorDisplay';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        
        <ErrorBoundary
          FallbackComponent={({ error, resetErrorBoundary }) => (
            <ErrorDisplay 
              error={error} 
              onRetry={resetErrorBoundary}
              fullScreen
              title="שגיאה בניתוב"
            />
          )}
        >
          <main className="main">
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/exhibition" element={<Exhibition />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/artist/:slug" element={<ArtistPage />} />
              <Route path="/artists/:slug" element={<ArtistPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </ErrorBoundary>
        
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default AppRouter;